import React, { ReactNode } from 'react';
import { useRoles } from 'src/provider/UserRoleProvider';
import { useFeatureFlagEnabled } from 'src/hooks/useFeatureFlagEnabled';
import { IM_PRICING_GDE_UI_RESELLERMANAGEMENT_ENABLED } from 'src/util/constants';
import BCNListDialogCommon from './BCNListDialogCommon';
import AddBcnPageNew from './BCNList/AddBcnPageNew';

type Props = Readonly<{
  BcnCameOnDeal: boolean;
  bcn_linking_level: string;
  branchCodes?: string[] | null;
  coG_Approval?: string;
  customerSetId: string;
  dealId: string;
  discountType?: string;
  generateQuote?: (selectedBcn: string[], disabled: boolean) => ReactNode;
  handleClose: () => void;
  isResolvedOnException: boolean;
  resellerAuth: string;
  resellerName: string;
  vendor_program_id?: string | number;
}>;

export default function ShowBCNListDialogNew(props: Props) {
  const { isCOGUser, isSalesUser, isVBMUser } = useRoles();
  const isResellerManagementEnabled = useFeatureFlagEnabled(
    IM_PRICING_GDE_UI_RESELLERMANAGEMENT_ENABLED
  );

  const isSalesWithoutCogApproval =
    isSalesUser && (props.coG_Approval ?? '').toUpperCase() === 'N';

  const showBCNAction = isCOGUser || isSalesWithoutCogApproval || isVBMUser;

  return (
    <BCNListDialogCommon
      {...props}
      AddBcnPageComponent={AddBcnPageNew}
      enablePagination={true}
      showBCNAction={showBCNAction}
      showResolutionType={isResellerManagementEnabled}
    />
  );
}
